import "./global.css";

import { Toaster } from "@/components/ui/toaster";
import { createRoot } from "react-dom/client";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HoleAuth0ProviderWithRouter, ProtectedRoute, AuthCallback } from "@hole/shared/auth";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import FOIAGenerator from "./pages/FOIAGenerator";
import TransparencyMap from "./pages/TransparencyMap";
import Login from "./pages/Login";
import Wiki from "./pages/Wiki";
import StateFOIA from "./pages/StateFOIA";
import FederalFOIA from "./pages/FederalFOIA";
import Privacy from "./pages/Privacy";
import CookieBanner from "@/components/CookieBanner";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <HoleAuth0ProviderWithRouter>
          <Routes>
            {/* Public routes - accessible to everyone */}
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/callback" element={<AuthCallback />} />

            {/* Transparency map and wiki - public access */}
            <Route path="/transparency-map" element={<TransparencyMap />} />
            <Route path="/wiki" element={<Wiki />} />
            <Route path="/wiki/:state" element={<StateFOIA />} />
            <Route path="/wiki/federal/foia" element={<FederalFOIA />} />

            {/* Protected routes - require authentication */}
            <Route path="/foia-generator" element={<ProtectedRoute component={FOIAGenerator} />} />

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </HoleAuth0ProviderWithRouter>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

createRoot(document.getElementById("root")!).render(<App />);
